import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "address": "Address",
      "loading": "Loading",
      "error": "Apologize, can't find your order",
      "storey": "Storey",
      "flat": "Flat",
      "type": "Supply",
      "total": "Total",
      "price": "Delivery price",
      "offer": "Offer",
      "topupToMinimum": "Topup to minimum",
      "driverTip": "Driver tip",
      "discount": "Discount",
      "serviceFee": "Service fee",
      "paymentMethod": "Payment method",
      "paymentSummary": "Payment summary",
      "bit": "bit",
      "card": "card",
      "cash": "cash",
      "bonus": "BONUS",
      "ASAP": "ASAP",
      "concreteTime": "Concrete time",
      "customerDetails": "Customer details",
      "notes": "Notes",
      "possible_extra": "Possible extra charge up to",
      "deliveryMethod": "Delivery method",
      "delivery": "Delivery",
      "email": "Email",
      "takeaway": "TakeAway",
      "dineIn": "DineIn",
      "cutlery": "Cutlery",
      "comment": "Comment",
      "name_on_box": "Name on box"
    },
  },
  he: {
    translation: {
      "address": "כתובת",
      "loading": " טעינה",
      "error": "לא מצאנו את הזמנתכם",
      "storey": "קומה",
      "flat": "דירה",
      "type": "אספקה",
      "total": "סה’’כ",
      "price": "דמי משלוח",
      "offer": "הצעה",
      "topupToMinimum": "השלמה למינימום הזמנה",
      "driverTip": "טיפ לשליח",
      "discount": "הנחה",
      "serviceFee": "דמי שירות",
      "paymentMethod": "שיטת תשלום",
      "paymentSummary": "סה’’כ",
      "bit": "ביט",
      "card": "כרטיס",
      "cash": "מזומן",
      "bonus": "בונוס",
      "ASAP": "אספקה מיידית",
      "concreteTime": "זמן בטון",
      "customerDetails": "פרטי הלקוח",
      "notes": "הערות",
      "possible_extra": "חיוב נוסף אפשרי עד",
      "deliveryMethod": "סוג הזמנה",
      "delivery": "משלוח",
      "email": "מייל",
      "takeaway": "איסוף עצמי",
      "dineIn": "ישיבה במקום",
      "cutlery": "סכו''מ",
      "comment": "הערה",
      "name_on_box": "שם על הקופסה"
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;